import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { SalesService } from '../../../services/sales.service';
import { ConfirmationService, MessageService, SharedModule } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoaderComponent } from '../../loader/loader.component';
import { FormsModule } from '@angular/forms';
import { EmailTemplateService } from '../../../services/email-template.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-contact-support-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, ReactiveFormsModule, FormsModule, ToastModule, ConfirmDialogModule, LoaderComponent],
  templateUrl: './contact-support-lookup.component.html',
  styleUrls: ['./contact-support-lookup.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ContactSupportLookupComponent {

  contactSupportForm = new FormGroup({
    useDefaultEmail: new FormControl(true),
    email: new FormControl({ value: ' ', disabled: true }, [Validators.email, Validators.required]),
    mobile: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10}$')]),
    subject: new FormControl('', Validators.required),
    description: new FormControl(''),
    urgency: new FormControl(''),
  });


  ngOnInit() {
    const defaultEmail = this.config?.data?.defaultEmail || '';

    if (this.contactSupportForm.get('useDefaultEmail')?.value) {
      this.contactSupportForm.get('email')?.setValue(defaultEmail);
      this.contactSupportForm.get('email')?.disable();
    }

    this.contactSupportForm.get('useDefaultEmail')?.valueChanges.subscribe(checked => {
      if (checked) {
        this.contactSupportForm.get('email')?.setValue(defaultEmail);
        this.contactSupportForm.get('email')?.disable();
      } else {
        this.contactSupportForm.get('email')?.enable();
        this.contactSupportForm.get('email')?.setValue('');
      }
    });
  }

  useDefaultEmail = false;
  selectedFile: File | null = null;
  submitted = false;
  loader: boolean = false;

  constructor(private salesService: SalesService, private messageService: MessageService, private dialogRef: DynamicDialogRef, private emailTemplateService: EmailTemplateService,
    private config: DynamicDialogConfig
  ) { }

  get formControls() {
    return this.contactSupportForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (!this.validateForm() || this.contactSupportForm.invalid) {
      return;
    }

    this.loader = true;

    const formValues = this.contactSupportForm.getRawValue();

    this.emailTemplateService.getTemplate('support-email-template').subscribe(template => {
      const htmlBody = this.emailTemplateService.replacePlaceholders(template, {
        email: formValues.email || '',
        mobile: formValues.mobile || '',
        subject: formValues.subject || '',
        description: formValues.description || '',
        urgency: formValues.urgency || ''
      });

      const formData = new FormData();
      formData.append('email', formValues.email || '');
      formData.append('mobile', formValues.mobile || '');
      formData.append('subject', formValues.subject || '');
      formData.append('description', formValues.description || '');
      formData.append('urgency', formValues.urgency || '');
      formData.append('htmlBody', htmlBody);

      if (this.selectedFile) {
        formData.append('attachment', this.selectedFile, this.selectedFile.name);
      }

      this.salesService.SendSupportRequest(formData).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Thanks for contacting us! We'll be in touch shortly.",
            life: 5000
          });

          this.CreateSupportRequest(formData);
          this.contactSupportForm.reset();
          this.submitted = false;
          this.selectedFile = null;
          this.loader = false;

          setTimeout(() => {
            this.dialogRef.close();
          }, 1000);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to send support request',
          });

          this.loader = false;
        },
      });
    });
  }

  CreateSupportRequest(data: any) {
    this.salesService.CreateSupportRequest(data).subscribe({
      next: (res: any) => {
        if (res?.success) {

          this.contactSupportForm.reset();
          this.submitted = false;
          this.selectedFile = null;
          this.loader = false;

          setTimeout(() => {
            this.dialogRef.close();
          }, 1000);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Something went wrong on the server.',
          });
          this.loader = false;
        }
      },
      error: (err) => {
        console.log(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to send support request',
        });
        this.loader = false;
      }
    });
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  validateForm() {
    let isValid = true;
    if (this.contactSupportForm.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Warning',
        detail: 'Please fill Required field',
      });
      isValid = false;
    }

    return isValid;
  }
}
